module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/mail_case_03-9edab31f75e79db3a89c87f6e268759b.png";